/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentBrowseIntentsQuery from './__generated__/VirtualAgentBrowseIntentsQuery$parameters';
import VirtualAgentBrowseIntents788BadPatternQuery from './__generated__/VirtualAgentBrowseIntents788BadPatternQuery$parameters';
import type { VirtualAgentBrowseIntents788BadPatternQuery as VirtualAgentBrowseIntents788BadPatternQueryType } from './__generated__/VirtualAgentBrowseIntents788BadPatternQuery.graphql';
import type { VirtualAgentBrowseIntentsQuery as VirtualAgentBrowseIntentsQueryType } from './__generated__/VirtualAgentBrowseIntentsQuery.graphql';

// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent-intents-browse-intents/src/ui/index.tsx
const DEFAULT_TIME_RANGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const formatFetchDate = (date: Date) => date.toISOString().substring(0, 10);

type BrowseIntentsEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentBrowseIntentsQueryType;
		statistics: VirtualAgentBrowseIntents788BadPatternQueryType;
	},
	{},
	{},
	{} | null
>;

export const browseIntentsEntryPoint: EntryPoint<
	BrowseIntentsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<BrowseIntentsEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-browse-intents" */ './VirtualAgentBrowseIntents.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: VirtualAgentBrowseIntentsQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
				},
			},
			statistics: {
				parameters: VirtualAgentBrowseIntents788BadPatternQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
					startDate: formatFetchDate(new Date(Date.now() - DEFAULT_TIME_RANGE_MS)),
					endDate: formatFetchDate(new Date()),
				},
			},
		},
	}),
});
